module.exports = __webpack_public_path__ + "img/feast_of_lights_flyer.c028e685.jpg";